export class EntityApi {
    static async request(op: string, params: any = {}, payload?: any) {
        const options: RequestInit = { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } };
        if (payload !== undefined) {
            options.method = 'POST';
            options.headers = { ...options.headers, 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' };
            options.body = new URLSearchParams({ payload: JSON.stringify(payload) }).toString();
        }
        const response = await fetch('/api/v1/entity-review?' + new URLSearchParams({ op, ...params }), options);
        const body = await response.json().catch(() => null);
        if (!response.ok || (typeof body?.code === 'number' && body.code >= 400)) throw new Error(body?.message || body?.data?.message || '요청을 처리하지 못했습니다. 다시 시도해주세요.');
        const outer = body?.data ?? body;
        const result = outer?.data ?? outer;
        if (!result || typeof result !== 'object') throw new Error('서버 응답을 확인하지 못했습니다.');
        return result;
    }
    static status(project: any) {
        const labels: any = { queued: '분석 대기', running: '분석 중', failed: '분석 오류', interrupted: '분석 중단', not_started: '분석 필요', outdated:'자료 변경 · 재분석 필요' };
        return labels[project.extraction_status] || (project.ner_document_count ? 'NER 재추출 반영' : project.index_count ? '추출 완료' : 'index 없음');
    }
    static nodeStatus(node: any) {
        if (node.review_status === 'completed') return '검수 완료';
        if (node.ner_applied) return 'NER 후보 ' + Number(node.ner_count || 0).toLocaleString() + '건';
        if (node.index_count) return 'index ' + node.index_count.toLocaleString() + '건';
        if (node.pdf_count && !node.body_chars) return 'PDF 본문 확인 필요';
        if (node.body_chars) return 'index 없음 · 본문 확인';
        return node.child_count ? '목차' : '본문 없음';
    }
}

export class EntityTree {
    public rows: any[] = [];
    public query = '';
    public loading = false;
    private epoch = 0;
    constructor(public item: string) { }
    async reset(query = '', current = () => true) {
        this.query = query;
        const epoch = ++this.epoch;
        this.loading = true;
        try {
            const data = await EntityApi.request('nodes', { item: this.item, q: query });
            if (epoch === this.epoch && current()) this.rows = this.makeRows(data, null, 0);
        } finally { if (epoch === this.epoch) this.loading = false; }
    }
    private makeRows(data: any, parent: string | null, indent: number) {
        const rows = data.nodes.map((node: any) => ({ ...node, indent, expanded: false }));
        if (data.page * data.limit < data.total) rows.push({ more: true, parent, page: data.page + 1, indent, remaining: data.total - data.page * data.limit });
        return rows;
    }
    async toggle(row: any, current = () => true) {
        if (row.more) return this.more(row, current);
        if (!row.child_count || row.loading || this.query) return;
        const position = this.rows.indexOf(row);
        if (row.expanded) {
            let end = position + 1;
            while (end < this.rows.length && this.rows[end].indent > row.indent) end++;
            this.rows.splice(position + 1, end - position - 1);
            row.expanded = false;
            return;
        }
        const epoch = this.epoch;
        row.loading = true;
        try {
            const data = await EntityApi.request('nodes', { item: this.item, parent: row.id });
            if (epoch !== this.epoch || !current() || !this.rows.includes(row)) return;
            this.rows.splice(this.rows.indexOf(row) + 1, 0, ...this.makeRows(data, row.id, row.indent + 1));
            row.expanded = true;
        } finally { row.loading = false; }
    }
    async more(row: any, current = () => true) {
        if (row.loading) return;
        const epoch = this.epoch;
        row.loading = true;
        try {
            const params: any = { item: this.item, page: row.page };
            if (this.query) params.q = this.query;
            else if (row.parent) params.parent = row.parent;
            const data = await EntityApi.request('nodes', params);
            if (epoch === this.epoch && current() && this.rows.includes(row)) this.rows.splice(this.rows.indexOf(row), 1, ...this.makeRows(data, row.parent, row.indent));
        } finally { row.loading = false; }
    }
}
